/**
 * Whether a sidebar nav `to` target should show the active state for the current URL.
 * Used by `Sidebar.tsx` only; exported for unit tests.
 */

function targetPath(to: string): string {
  const i = to.indexOf('?');
  return i >= 0 ? to.slice(0, i) : to;
}

export function navItemActive(to: string, pathname: string, search: string): boolean {
  const tp = targetPath(to);
  if (to.includes('?')) {
    if (pathname !== tp) return false;
    const qPart = to.split('?')[1] ?? '';
    const want = new URLSearchParams(qPart);
    const have = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
    for (const [k, v] of want) {
      if (have.get(k) !== v) return false;
    }
    return true;
  }
  const normPath = pathname.replace(/\/$/, '') || '/';
  const normTp = tp.replace(/\/$/, '') || '/';
  if (normPath === normTp) return true;
  // Tenant hub URL is /tenants/:id only — do not treat …/bots, …/users, etc. as "Home"
  if (/^\/tenants\/[^/]+$/.test(normTp)) {
    return false;
  }
  if (tp === '/livechat' && pathname.startsWith('/livechat/')) return false;
  if (tp === '/analytics') return pathname === '/analytics';
  if (tp === '/platform/users') return pathname === '/platform/users';
  if (tp === '/agent-analytics' && pathname.startsWith('/agent-analytics')) return true;
  if (tp === '/reporting' && pathname.startsWith('/reporting')) return true;
  if (tp === '/tickets' && pathname.startsWith('/tickets')) return true;
  if (tp === '/config' && pathname.startsWith('/config')) return true;
  if (tp === '/announcements' && pathname.startsWith('/announcements')) return true;
  if (tp === '/internal-chat-logs' && pathname.startsWith('/internal-chat-logs')) return true;
  if (tp === '/developer-docs' && pathname.startsWith('/developer-docs')) return true;
  if (tp === '/help') return pathname === '/help';
  if (tp === '/help/agent') {
    return pathname === '/help/agent' || pathname.startsWith('/help/agent/');
  }
  return pathname.startsWith(tp + '/');
}
